module.exports = __webpack_public_path__ + "img/img74.5e0e673e.svg";